import Close from '@service-victoria/component-library/components/Icons/Close';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: stretch;
  padding: 32px 22px;
`;

export const ModalTitle = styled.h1`
  margin: 0;
  margin-bottom: 20px;
  font-family: VIC;
  font-size: 1.625rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.21px;
  color: ${colors.blueGrey};
  z-index: 1500;

  &:focus {
    outline: none;
  }
`;

export const ModalBody = styled.div<{ hasActions: boolean }>`
  width: 100%;
  margin: 0;
  margin-bottom: ${({ hasActions }) => (hasActions ? '0' : '40px')};
  font-family: VIC;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.21px;
  color: ${colors.blueGrey};
`;

export const IconContainer = styled.button`
  display: inline-block;
  margin-left: auto;
  padding: 5px;
  background: none;
  border: none;
  align-self: flex-start;

  &:hover {
    cursor: pointer;
  }
`;

export const IconBox = styled(Close)`
  width: 20px;
  height: 20px;
  color: ${colors.blueGrey};
`;

export const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const ActionsContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 40px;

  @media ${device.isMobile} {
    width: 100%;

    button:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  @media ${device.isDesktop}, ${device.isTablet} {
    flex-direction: row-reverse;
    justify-content: flex-start;

    button:not(:last-child) {
      margin-left: 16px;
    }
  }
`;
